(function($) {
	
	class PushLogic_Resellers  {
		
		constructor()
		{
			this.update_attributes();
		}

		update_attributes()
		{
			var reseller_id = localStorage.getItem('ttmb_reseller_id'),
                reseller_name = localStorage.getItem('ttmb_reseller_name');
				
			if(reseller_id && reseller_name)
			{
				$.post('/cart/update.js', {
                  attributes : {"Reseller ID": reseller_id, "Reseller Name": reseller_name}
                });
			}
		}
	}
	
	new PushLogic_Resellers;

})(jQuery);
